module.exports = __webpack_public_path__ + "assets/img/btn-view-b782fef8.png";